import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { MaskLines, Overline, Reveal } from "./Reveal";

const faqs = [
  ["How long does a typical AI project take?", "It depends on scope. We usually start with a short discovery phase, then deliver a working prototype before scaling to production. We'll share a concrete timeline after our first conversation."],
  ["How do you handle data privacy and security?", "Your data stays under your control. We design for least-privilege access, can deploy in your own cloud, and choose model providers and settings that match your compliance needs."],
  ["Do you build custom models or use existing LLMs?", "Both. Many problems are solved best with a well-grounded foundation model; others need custom-trained or fine-tuned models. We recommend what fits your data, cost and accuracy goals."],
  ["Can you work with our existing team and systems?", "Yes. We integrate with your current data sources, tools and engineers, and can hand over fully documented systems or keep supporting them after launch."],
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-24 sm:px-6 md:py-36 lg:grid-cols-12 lg:px-8">
    <div className="lg:col-span-5">
      <Overline color="bg-amber">05 — FAQ</Overline>
      <h2 className="font-display text-5xl leading-[1] tracking-tight text-ink sm:text-6xl">
        <MaskLines inView lines={["Questions,", <em className="text-violet">answered.</em>]} />
      </h2>
    </div>
    <Reveal className="lg:col-span-7" delay={0.1}>
      <Accordion type="single" collapsible defaultValue="item-0">
        {faqs.map(([q, a], i) => (
          <AccordionItem key={q} value={`item-${i}`} data-testid={`faq-item-${i + 1}`} className="border-ink/15">
            <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="py-6 text-left font-display text-2xl font-normal text-ink hover:no-underline sm:text-3xl">{q}</AccordionTrigger>
            <AccordionContent className="pb-6 text-base leading-relaxed text-ink/75">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
